export const defaultTemplates = {
  'Default': 'default',
  'Default Empty': 'empty',
  'Code Languages': 'coding',
  'Elements': 'elements',
  'EightBit': '8bit'
}